module.exports = __webpack_public_path__ + "img/icon_city9.6335933c.png";